import React from 'react';

const UPADEVATHAS = [
  {
    name: 'Hanuman',
    color: 'from-yellow-100 to-orange-100',
    description: <>The brave <strong>Hanuman</strong> guards from the <strong>south-eastern</strong> side of the temple.</>,
  },
  {
    name: 'Maha Ganapathy',
    color: 'from-pink-100 to-red-100',
    description: <>The remover of obstacles, <strong>Maha Ganapathy</strong>, is consecrated inside the <em>Nalambalam</em> in the <strong>south-west</strong>.</>,
  },
  {
    name: 'Sree Nagaraja and Nagayakshi',
    color: 'from-green-100 to-blue-100',
    description: <><strong>Sree Nagaraja and Nagayakshi</strong> have their shrine <strong>south-east of the Hanuman Kovil</strong>.</>,
  },
];

const Upadevathas = () => (
  <div className="card-temple mb-12">
    <h3 className="text-2xl font-bold text-saffron mb-8 text-center">
      Upadevathas Around the Main Shrine
    </h3>
    
    <p className="text-lg text-gray-700 mb-8 text-center leading-relaxed">
      Encircling the main shrine, a host of Upadevathas found their homes:
    </p>
    
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
      {UPADEVATHAS.map((deity) => (
        <div key={deity.name} className={`text-center p-6 bg-gradient-to-br ${deity.color} rounded-lg`}>
          <h4 className="font-semibold text-saffron mb-2">{deity.name}</h4>
          <p className="text-sm text-gray-700">{deity.description}</p>
        </div>
      ))}
    </div>
    
    <div className="mt-8 text-center">
      <img
        src="https://customer-assets.emergentagent.com/job_krishna-temple/artifacts/1s9em2y0_Upadevathas_20251001_200117_0000.png"
        alt="Upadevathas around the main shrine"
        className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
      />
    </div>
  </div>
);

export default Upadevathas;
